import { tss } from 'tss-react/mui';

export const useVoiceSettingsStyles = tss.create(({ theme }) => ({
  dialogHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  dialogTitle: {
    padding: theme.spacing(0),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
  },
  providerGroup: {
    marginTop: theme.spacing(1),
  },
  section: {
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.border.default}`,
    borderRadius: theme.shape.borderRadius,
    '&:before': { display: 'none' },
  },
  summaryRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  sectionError: {
    borderColor: theme.palette.error.main,
  },
  fieldsGrid: {
    display: 'grid',
    gap: theme.spacing(1),
    minWidth: 0,
    gridTemplateColumns: 'minmax(0, 1fr)',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    '& > *': { minWidth: 0 },
  },
}));
